import {
  GROUP_COOKIE,
  getTenantGroupKey,
  parseGroupCookie,
  type GroupAttributes,
} from '../openfeature/cacheKey'

/**
 * The attributes of the group the page is built for, on both sides: the request
 * context the gate filled on the server, the group cookie in the browser.
 *
 * A rendered page is cached for a group, so anything the markup depends on has
 * to be answered from the group and not from the browser it happens to be
 * hydrating in, or the two disagree and Vue calls it a hydration mismatch. The
 * browser wrote the cookie from its own truth, so on the client this agrees
 * with what the browser would say, only earlier and on the server too.
 *
 * Null without a group, which is the client shell, where nothing is cached and
 * the browser's own answers are the ones to use.
 */
export function groupAttributes(): GroupAttributes | null {
  const groupKey = getTenantGroupKey(useAppConfig().tenant ?? '')
  if (!groupKey?.enforce) return null
  if (import.meta.server) {
    return useRequestEvent()?.context.ssrGroup?.attributes ?? null
  }
  return parseGroupCookie(groupKey.tenant, useCookie(GROUP_COOKIE).value ?? '')
}
